module.exports = __webpack_public_path__ + "static/media/c-pop-up-8.57e98b6a.png";